// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { md5 } from '@tcp/core/src/utils/encoding';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import confirmationSelectors from '@tcp/core/src/components/features/CnC/Confirmation/container/Confirmation.selectors';
import { routerReplace, removeSessionStorage } from '@tcp/core/src/utils';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { openAccountDrawer } from '@tcp/core/src/components/common/organisms/Header/container/Header.actions';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import BAG_PAGE_ACTIONS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import LoginPageReducer from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.reducer';
import { LoginPageSaga } from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.saga';
import { CONTACT_FORM } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import {
  login,
  setExistingUserResponse,
  resetLoginInfo,
  generateLoginOTP,
} from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.actions';
import {
  getExistingUserResponse,
  getLoginError,
  getLoginState,
  getOTPToken,
  getLoadingState,
  shouldShowRecaptcha,
  getIsNewLoginScreenApp,
} from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.selectors';
import getErrorMessage from '@tcp/core/src/components/features/account/LoginPage/container/loginUtils/loginErrorMessage.util';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { SPC_SECTION } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import { getSinglePageCheckoutSectionState } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  getContactFormValuesFromSS,
  setContactFormValuesInSS,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { saveUserEmailAddress } from '../../ForgotPassword/container/ForgotPassword.actions';
import { routerPush, getUrlParameter } from '../../../../../utils';
import CreateAccountView from '../views/CreateAccountView';
import {
  createAccount,
  resetCreateAccountErr,
  setIsFromCreateAccountFlow,
  setShowOTPScreen,
  setLoadingState,
} from './CreateAccount.actions';
import {
  getIAgree,
  getHideShowPwd,
  getConfirmHideShowPwd,
  getErrorMessage as getErrorMessageCreateAcc,
  getLoadingState as getLoadingStateCreateAcc,
  getIsShowOTPScreen,
  getShowVerificationError,
  getErrorCode,
} from './CreateAccount.selectors';
import {
  getUserLoggedInState,
  getplccCardId,
  getplccCardNumber,
  getUserEmail,
} from '../../User/container/User.selectors';
import { API_CONFIG } from '../../../../../services/config';
import {
  closeOverlayModal,
  openOverlayModal,
} from '../../OverlayModal/container/OverlayModal.actions';
import { getResetPassCodeValidationFlow } from '../../ResetPassword/container/ResetPassword.selectors';

import { setClickAnalyticsData, trackClick } from '../../../../../analytics/actions';
import {
  getBonusPointsEventMessaging,
  getIsOTpScreenEnabled,
  getIsSnjPjpBrandDisabled,
  getPageNameFromState,
  getCheckoutMetricsStatus,
  getIsInternationalPhoneNumber,
  getLoginFlowUXEnhancement,
  getIsUpdatedCanadaTermsAndConditions,
  getIsHideLoginLoader,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  CUSTOMER_HELP_DIRECT_LINK_TEMPLATE,
  CUSTOMER_HELP_DIRECT_ROUTES,
} from '../../CustomerHelp/CustomerHelp.constants';
import { CHECKOUT_ROUTES } from '../../../CnC/Checkout/Checkout.constants';
import { CreateAccountSaga } from './CreateAccount.saga';
import CreateAccountReducer from './CreateAccount.reducer';
import { updateSectionState } from '../../../CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import { setCheckoutMetricsStatus } from '../../../../../reduxStore/actions';

const registerCheckoutUrl = 'register-checkout';
const noop = () => {};
const isSafari =
  typeof window !== 'undefined' &&
  (window?.safari !== undefined || window?.navigator?.vendor?.includes('Apple'));
export class CreateAccountContainer extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    createAccountAction: PropTypes.func,
    hideShowPwd: PropTypes.bool,
    confirmHideShowPwd: PropTypes.bool,
    error: PropTypes.string,
    openOverlay: PropTypes.func,
    onRequestClose: PropTypes.func,
    isIAgreeChecked: PropTypes.bool,
    resetAccountError: PropTypes.func,
    isUserLoggedIn: PropTypes.bool,
    closeOverlay: PropTypes.func,
    navigation: PropTypes.shape({}),
    setLoginModalMountState: PropTypes.bool.isRequired,
    showLogin: PropTypes.func.isRequired,
    userplccCardNumber: PropTypes.string.isRequired,
    userplccCardId: PropTypes.string.isRequired,
    toastMessage: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    updateHeader: PropTypes.func,
    showCheckoutModal: PropTypes.func.isRequired,
    isResetPassCodeValidationEnabled: PropTypes.bool.isRequired,
    existingUserInformation: PropTypes.shape({}),
    fullPageView: PropTypes.bool,
    userEmail: PropTypes.string,
    router: PropTypes.shape({}),
    isRegisteredUserCallDone: PropTypes.bool,
    loyaltyPageName: PropTypes.string,
    spc: PropTypes.bool,
    openAccountDrawerModal: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    createAccountAction: noop,
    hideShowPwd: false,
    confirmHideShowPwd: false,
    error: '',
    openOverlay: noop,
    onRequestClose: noop,
    isIAgreeChecked: false,
    resetAccountError: noop,
    closeOverlay: noop,
    isUserLoggedIn: false,
    navigation: {},
    toastMessage: () => {},
    updateHeader: () => {},
    existingUserInformation: {},
    fullPageView: false,
    userEmail: '',
    router: {},
    isRegisteredUserCallDone: false,
    loyaltyPageName: 'account',
    spc: false,
  };

  formSubmissionTriggered = false;

  shouldRedirect = false;

  componentDidMount() {
    const { isUserLoggedIn, closeOverlay } = this.props;
    if (isUserLoggedIn && window.location.href.includes(registerCheckoutUrl)) {
      closeOverlay();
      routerReplace('/bag', '/bag');
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  componentDidUpdate(prevProps) {
    const { isUserLoggedIn, closeOverlay, userEmail } = this.props;

    if (!prevProps.isUserLoggedIn && isUserLoggedIn) {
      this.shouldRedirect = true;
      if (userEmail && window && window._dataLayer) {
        const hash = md5(userEmail.toUpperCase());
        setLocalStorage({ key: 'email_hash', value: hash });
        /* eslint no-underscore-dangle: 0 */
        window._dataLayer.email_hash = hash;
      }
      const closeOverlayTimeout = setTimeout(() => {
        closeOverlay();
        clearTimeout(closeOverlayTimeout);
      }, API_CONFIG.overlayTimeout);
      const redirectonsuccess = getUrlParameter('redirectOnSuccess');
      if (redirectonsuccess) {
        routerPush('/account?id=profile', redirectonsuccess);
      } else {
        this.handleSuccessRedirection();
      }
    }
  }

  componentWillUnmount() {
    const {
      resetAccountError,
      showOtpScreen,
      setIsFromCreateAccount,
      setLoader,
      isOTpScreenEnabled,
      resetLoginState,
      loginError,
    } = this.props;
    resetAccountError();
    showOtpScreen();
    setIsFromCreateAccount(false);
    setLoader(false);
    if (loginError && isOTpScreenEnabled) {
      resetLoginState();
    }
  }

  navigate = () => {
    const { emailAddressFromSS } = this.props;

    const updatedContactFormValues = {
      ...emailAddressFromSS,
      isCreateAccountOtpScreen: false,
    };
    setContactFormValuesInSS({ ...updatedContactFormValues });
    if (
      window.location.href.includes(registerCheckoutUrl) &&
      !window?.location?.href.includes('from=SA')
    ) {
      routerPush(
        CHECKOUT_ROUTES.singlePageCheckoutPage.to,
        CHECKOUT_ROUTES.singlePageCheckoutPage.asPath,
        { shallow: true }
      );
    } else {
      routerPush('/', '/home');
    }
  };

  isBagPageFlow = (successtarget) => {
    return successtarget?.includes('bag');
  };

  handleSuccessRedirection = () => {
    const { fullPageView, router } = this.props;
    const { successtarget = '/home' } = (router && router.query) || {};

    if (fullPageView) {
      const timeoutValue = !this.formSubmissionTriggered ? 0 : API_CONFIG.overlayTimeout;
      const closeOverlayTimeout = setTimeout(() => {
        if (
          successtarget === '/home' ||
          successtarget.substr(-5) === '/home' ||
          successtarget.indexOf('confirmation') !== -1 ||
          successtarget.indexOf('login') !== -1
        ) {
          this.navigate();
        } else if (
          successtarget.indexOf(CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.MERGE_MYPLACE_ACCOUNTS) !== -1
        ) {
          routerReplace(
            CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.to,
            CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.asPath
          );
        } else if (window.history && window.history.back) {
          window.history.back();
        }
        this.openAccountModal();
        clearTimeout(closeOverlayTimeout);
      }, timeoutValue);
    } else {
      this.navigate();
    }
  };

  openAccountModal = () => {
    const { openAccountDrawerModal, router } = this.props;
    const { successtarget } = (router && router.query) || {};

    if (!this.isBagPageFlow(successtarget) && !window.location.href.includes(registerCheckoutUrl)) {
      openAccountDrawerModal();
    }
  };

  onAlreadyHaveAnAccountClick = (e) => {
    e.preventDefault();
    const {
      openOverlay,
      setLoginModalMountState,
      fullPageView,
      resetLoginState,
      showOtpScreen,
      isOTpScreenEnabled,
      setIsFromCreateAccount,
      saveExistingUserResponse,
    } = this.props;
    const { pathname = 'referrer' } = (window && window.location) || {};
    if (isOTpScreenEnabled) {
      showOtpScreen();
      setIsFromCreateAccount(false);
      resetLoginState();
      saveExistingUserResponse('');
      removeSessionStorage(CONTACT_FORM);
    }
    if (setLoginModalMountState) {
      setLoginModalMountState({
        component: 'login',
      });
    } else if (fullPageView) {
      routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
    } else {
      openOverlay({
        component: 'login',
        variation: 'primary',
      });
    }
  };

  openModal = (params) => {
    const { openOverlay, setLoginModalMountState } = this.props;
    if (setLoginModalMountState) {
      setLoginModalMountState(params);
    } else {
      openOverlay(params);
    }
  };

  submitCreateAccountForm = (payload) => {
    const { createAccountAction } = this.props;
    this.formSubmissionTriggered = true;
    createAccountAction(payload);
  };

  render() {
    const {
      className,
      isIAgreeChecked,
      hideShowPwd,
      confirmHideShowPwd,
      error,
      onRequestClose,
      fromLoginModal,
      showLogin,
      isUserLoggedIn,
      userplccCardNumber,
      userplccCardId,
      toastMessage,
      isLoading,
      updateHeader,
      showCheckoutModal,
      closeOverlay,
      isResetPassCodeValidationEnabled,
      existingUserInformation,
      fullPageView,
      isRegisteredUserCallDone,
      loyaltyPageName,
      spc,
      closeAnimationModel,
      fromOnBoarding,
      isNewRegisteredFlow,
      variation,
      isBonusPointsEventMessagingEnabled,
      isShowOTPInputScreenCreateAccount,
      routeForBagCheckout,
      saveExistingUserResponse,
      isOTpScreenEnabled,
      userEmail,
      showOtpScreen,
      onSubmit,
      existingUserResponse,
      loginState,
      loginError,
      resetLoginState,
      otpToken,
      onGenerateOTP,
      setIsFromCreateAccount,
      isLoginLoading,
      setLoader,
      emailAddressFromSS,
      isNewLoginScreenApp,
      handleContinueAsGuest,
      onUpdateSectionState,
      setOnSubmitLoader,
      onPressHandlerForGuestOnBoarding,
      isInternationalPhoneNumberEnabled,
      dispatchFormFieldChange,
      dispatchFormFieldChangeApp,
      isUpdatedCanadaTermsAndConditions,
      isHideLoginLoader,
      ...others
    } = this.props;
    const errorMessage = loginError ? getErrorMessage(loginState) : '';

    const showSkeleton =
      fullPageView &&
      (!isRegisteredUserCallDone || (this.shouldRedirect && !this.formSubmissionTriggered));
    let isFromCheckout;
    if (window?.location?.href.includes('from=SA')) {
      isFromCheckout = false;
    } else if (window?.location?.href.includes(registerCheckoutUrl)) {
      isFromCheckout = true;
    } else {
      isFromCheckout = false;
    }
    return (
      <CreateAccountView
        className={className}
        createAccountAction={this.submitCreateAccountForm}
        isIAgreeChecked={isIAgreeChecked}
        isSafari={isSafari}
        hideShowPwd={hideShowPwd}
        confirmHideShowPwd={confirmHideShowPwd}
        error={error}
        onAlreadyHaveAnAccountClick={this.onAlreadyHaveAnAccountClick}
        onRequestClose={onRequestClose}
        fromLoginModal={fromLoginModal}
        openModal={this.openModal}
        showLogin={showLogin}
        isUserLoggedIn={isUserLoggedIn}
        userplccCardNumber={userplccCardNumber}
        userplccCardId={userplccCardId}
        toastMessage={toastMessage}
        isLoading={isLoading}
        updateHeader={updateHeader}
        showCheckoutModal={showCheckoutModal}
        closeOverlay={closeOverlay}
        isResetPassCodeValidationEnabled={isResetPassCodeValidationEnabled || fromOnBoarding}
        existingUserInformation={existingUserInformation}
        fullPageView={fullPageView}
        formSubmissionTriggered={this.formSubmissionTriggered}
        showSkeleton={showSkeleton}
        loyaltyPageName={loyaltyPageName}
        spc={spc}
        closeAnimationModel={closeAnimationModel}
        fromOnBoarding={fromOnBoarding}
        isNewRegisteredFlow={isNewRegisteredFlow}
        variation={variation}
        isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
        isShowOTPInputScreen={isShowOTPInputScreenCreateAccount}
        isFromCheckout={isFromCheckout}
        routeForBagCheckout={routeForBagCheckout}
        saveExistingUserResponse={saveExistingUserResponse}
        isOTpScreenEnabled={isOTpScreenEnabled}
        userEmail={userEmail}
        showOtpScreen={showOtpScreen}
        onSubmit={onSubmit}
        existingUserResponse={existingUserResponse}
        loginErrorMessage={errorMessage}
        resetLoginState={resetLoginState}
        otpToken={otpToken}
        onGenerateOTP={onGenerateOTP}
        setIsFromCreateAccount={setIsFromCreateAccount}
        isLoginLoading={isLoginLoading}
        setLoader={setLoader}
        sessionStorageUserInfo={emailAddressFromSS}
        isNewLoginScreenApp={isNewLoginScreenApp}
        handleContinueAsGuest={handleContinueAsGuest}
        onUpdateSectionState={onUpdateSectionState}
        isShowOTPInputScreenCreateAccount={isShowOTPInputScreenCreateAccount}
        setOnSubmitLoader={setOnSubmitLoader}
        onPressSetupLater={onPressHandlerForGuestOnBoarding}
        isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
        dispatchFormFieldChange={dispatchFormFieldChange}
        dispatchFormFieldChangeApp={dispatchFormFieldChangeApp}
        isUpdatedCanadaTermsAndConditions={isUpdatedCanadaTermsAndConditions}
        isHideLoginLoader={isHideLoginLoader}
        {...others}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);

  return {
    isIAgreeChecked: getIAgree(state),
    hideShowPwd: getHideShowPwd(state),
    confirmHideShowPwd: getConfirmHideShowPwd(state),
    isUserLoggedIn: getUserLoggedInState(state),
    userplccCardNumber: getplccCardNumber(state),
    userplccCardId: getplccCardId(state),
    error: getErrorMessageCreateAcc(state),
    isLoading: getLoadingStateCreateAcc(state),
    isResetPassCodeValidationEnabled: getResetPassCodeValidationFlow(state),
    existingUserInformation: confirmationSelectors.getInitialCreateAccountValues(state),
    userEmail: getUserEmail(state),
    loyaltyPageName: getPageNameFromState(state),
    isBonusPointsEventMessagingEnabled: getBonusPointsEventMessaging(state),
    isSnjPjpBrandDisabled: getIsSnjPjpBrandDisabled(state),
    isShowOTPInputScreenCreateAccount: getIsShowOTPScreen(state),
    isOTpScreenEnabled: getIsOTpScreenEnabled(state),
    existingUserResponse: getExistingUserResponse(state),
    loginError: getLoginError(state),
    loginState: getLoginState(state),
    otpToken: getOTPToken(state),
    isLoginLoading: getLoadingState(state),
    emailAddressFromSS: getContactFormValuesFromSS(contactData),
    showVerificationError: getShowVerificationError(state),
    showRecaptcha: shouldShowRecaptcha(state),
    isNewLoginScreenApp: getIsNewLoginScreenApp(state),
    createAccountError: getErrorCode(state),
    checkoutGuestStatus: getCheckoutMetricsStatus(state, 'checkout_as_guest'),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    loginFlowUXEnhancementEnabled: getLoginFlowUXEnhancement(state),
    isUpdatedCanadaTermsAndConditions: getIsUpdatedCanadaTermsAndConditions(state),
    isHideLoginLoader: getIsHideLoginLoader(state),
  };
};

export const mapDispatchToProps = (dispatch, props) => {
  const { handleAfterLogin, fromOnBoarding } = props || {};
  return {
    createAccountAction: (payload) => {
      dispatch(createAccount({ ...payload, handleAfterLogin, fromOnBoarding }));
    },
    closeOverlay: () => {
      dispatch(closeOverlayModal());
    },
    openOverlay: (payload) => {
      dispatch(openOverlayModal(payload));
    },
    openAccountDrawerModal: () => {
      dispatch(openAccountDrawer());
    },
    resetAccountError: () => {
      dispatch(resetCreateAccountErr());
    },
    toastMessage: (error) => {
      dispatch(toastMessageInfo(error));
    },
    trackAnalyticsClick: (payload, eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    showOtpScreen: () => {
      dispatch(setShowOTPScreen(false));
    },
    setIsFromCreateAccount: (payload) => {
      dispatch(setIsFromCreateAccountFlow(payload));
    },
    routeForBagCheckout: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.routeForCheckout(payload));
    },
    saveExistingUserResponse: (payload) => {
      dispatch(setExistingUserResponse(payload));
    },
    onSubmit: (payload) => {
      const { isRtpsFlow = false } = props;
      let isFromCheckout;
      if (window?.location?.href.includes('from=SA')) {
        isFromCheckout = false;
      } else if (window?.location?.href.includes(registerCheckoutUrl)) {
        isFromCheckout = true;
      } else {
        isFromCheckout = false;
      }

      dispatch(saveUserEmailAddress(payload.emailAddress));
      const modfiedPayload = {
        ...payload,
        mergeCart: !isRtpsFlow && !isFromCheckout,
        fromCreateAccount: true,
      };

      dispatch(login(modfiedPayload, handleAfterLogin));
    },
    resetLoginState: () => {
      dispatch(resetLoginInfo());
    },
    onGenerateOTP: (payload) => {
      dispatch(generateLoginOTP(payload));
    },
    setLoader: (payload) => dispatch(setLoaderState(payload)),
    onUpdateSectionState: (payload) => {
      dispatch(updateSectionState(payload));
    },
    setOnSubmitLoader: () => dispatch(setLoadingState({ isLoading: true })),
    setOffSubmitLoader: () => dispatch(setLoadingState({ isLoading: false })),
    setCheckoutEmailGuestStatus: (payload) => {
      dispatch(setCheckoutMetricsStatus(payload));
    },
    dispatchFormFieldChange: (key, value) => dispatch(change('CreateAccountForm', key, value)),
    dispatchFormFieldChangeApp: (key, value) => dispatch(change('myCreateAccountForm', key, value)),
  };
};
const withReducer = withDynamicReducer([
  {
    key: 'CreateAccountReducer',
    reducer: CreateAccountReducer,
  },
  { key: 'LoginPageReducer', reducer: LoginPageReducer },
]);
const withSaga = useDynamicSaga([
  { key: 'CreateAccountSaga', saga: CreateAccountSaga },
  { key: 'LoginPageSaga', saga: LoginPageSaga },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(CreateAccountContainer);
// export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountContainer);
